import useStoreSchema from 'lib/reusable-components/reusableUtils/commons/useStoreSchema';
import { mls } from 'lib/multilanguagesupport';
import { Alert } from 'react-bootstrap-v5';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { useDispatch } from 'react-redux';
import { create } from 'lib/reusable-components/reusableUtils/redux/stateSlice';
import { useEffect, useRef } from 'react';

function MessageHandling() {
  const dispatch = useDispatch();
  const toastTimeout = useRef();
  const errToastTimeout = useRef();
  const toastData = useStoreSchema(
    reduxConstants.STORE_NAME,
    reduxConstants.config.APP_STATUS.TOAST
  );
  const errorToastData = useStoreSchema(
    reduxConstants.STORE_NAME,
    reduxConstants.config.APP_STATUS.ERROR_TOAST
  );
  const returnObj = [];
  if (toastData?.isActive) {
    returnObj.push(
      <Alert
        key={toastData.message}
        variant='success'
        className='fixed-bottom w-lg-25 w-sm-75 w-md-50'
        style={{ bottom: 15, left: 15, zIndex: 9000 }}
      >
        {mls(toastData.message)}
      </Alert>
    );
    // clearTimeout(toastTimeout.current);
    toastTimeout.current = setTimeout(() => {
      dispatch(
        create({
          setPath: reduxConstants.config.APP_STATUS.TOAST,
          value: {},
        })
      );
    }, (toastData?.time || 5) * 1000);
  }
  if (errorToastData?.isActive) {
    returnObj.push(
      <Alert
        key={errorToastData.message}
        variant='danger'
        className='fixed-bottom w-lg-25 w-sm-75 w-md-50'
        style={{ bottom: 15, left: 15, zIndex: 9000 }}
      >
        {mls(errorToastData.message)}
      </Alert>
    );
    // clearTimeout(errToastTimeout.current);
    errToastTimeout.current = setTimeout(() => {
      dispatch(
        create({
          setPath: reduxConstants.config.APP_STATUS.ERROR_TOAST,
          value: {},
        })
      );
    }, (errorToastData?.time || 5) * 1000);
  }
  return <>{returnObj}</>;
}

export default MessageHandling;
